import React from "react";
import Title from "./Title";
import Content from "./Content";
import { PageContentWrapper } from "../../shared/styled/PageContentStyle";

const AccountingAccounts = () => {
    return (
        <PageContentWrapper>
            <Title />
            <Content />
        </PageContentWrapper>
    );
};

export default AccountingAccounts;
